export default __webpack_public_path__ + "static/media/GREEN_STOREYS_BROCHURE.a3d661fc.pdf";